import { useEffect, useState } from "react";
import { useListContext } from "react-admin";
import { DateRangePicker } from "rsuite";
import { useDispatch } from "react-redux";
import { setPurchaseLogFilter } from "src/slices/purchaseLogPage/filterPurchaseLogSlice";
import { setSmsLogFilter } from "src/slices/smsLogPage/filterSmsLogSlice";
import { setVoiceLogFilter } from "src/slices/voiceLogPage/filterVoiceLogSlice";
import { setReloadLogFilter } from "src/slices/reloadLogPage/filterReloadLogSlice";
import { setSubscribersFilter } from "src/slices/subscribersPage/filterSubscribersSlice";
import { setBannerPromotionsFilter } from "src/slices/bannerPromotionsPage/bannerPromotionsSlice";
import { setBroadcastFilter } from "src/slices/broadCastPage/broadcastSlice";
import { setSaleProgramFilter } from "src/slices/saleProgramsPage/filterSaleProgramSlice";
import { setReferralBenefitFilter } from "src/slices/referralBenefitsPage/filterReferralBenefitSlice";
import { setDeviceLogsFilter } from "src/slices/deviceLogsPage/filterDeviceLogsSlice";
import { setMvnoFilter } from "src/slices/mvnoPage/filterMvnoSlice";
import { useLocation } from "react-router-dom";
import "rsuite/dist/rsuite.min.css";
import moment from "moment";

export const DateRange = (props: any) => {
  const { filterValues, displayedFilters, setFilters } = useListContext();
  const dispatch = useDispatch();
  const location = useLocation();

  const [dateValue, setDateValue] = useState<any>({
    dateGte: filterValues.dateGte
      ? moment(filterValues.dateGte).startOf("day").toDate()
      : null,
    dateLte: filterValues.dateLte
      ? moment(filterValues.dateLte).endOf("day").toDate()
      : null,
  });

  function purchaseLogPageDateRange() {
    dispatch(
      //@ts-ignore
      setPurchaseLogFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function mvnoPageDateRange() {
    dispatch(
      setMvnoFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function smsLogPageDateRange() {
    dispatch(
      //@ts-ignore
      setSmsLogFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function voiceLogpageDateRange() {
    dispatch(
      //@ts-ignore
      setVoiceLogFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function reloadLogPageDateRange() {
    dispatch(
      //@ts-ignore
      setReloadLogFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function subscribersPageDateRange() {
    dispatch(
      //@ts-ignore
      setSubscribersFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function bannerPromotionsPageDateRange() {
    dispatch(
      setBannerPromotionsFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function broadcastPageDateRange() {
    dispatch(
      //@ts-ignore
      setBroadcastFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function saleProgramPageDateRange() {
    dispatch(
      //@ts-ignore
      setSaleProgramFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function referralBenefitPageDateRange() {
    dispatch(
      //@ts-ignore
      setReferralBenefitFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  function deviceLogsPageDateRange() {
    dispatch(
      setDeviceLogsFilter({
        dateGte: dateValue.dateBegin,
        dateLte: dateValue.dateEnd,
      })
    );
  }

  useEffect(() => {
    switch (location.pathname) {
      case "/usages/purchase":
        purchaseLogPageDateRange();
        break;
      case "/usages/mvno":
        mvnoPageDateRange();
        break;
      case "/usages/sms":
        smsLogPageDateRange();
        break;
      case "/usages/voice":
        voiceLogpageDateRange();
        break;
      case "/usages/reload":
        reloadLogPageDateRange();
        break;
      case "/subscribers":
        subscribersPageDateRange();
        break;
      case "/promotionsBanner":
        bannerPromotionsPageDateRange();
        break;
      case "/promotions/broadcast":
        broadcastPageDateRange();
        break;
      case "/promotions/flashsale":
        saleProgramPageDateRange();
        break;
      case "/promotions/referral_benefits":
        referralBenefitPageDateRange();
        break;
      case "/internal/device-logs":
        deviceLogsPageDateRange();
        break;
      default:
        console.log("default");
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, dateValue]);

  return (
    <DateRangePicker
      format="MM/dd/yyyy hh:mm:ss aa"
      showMeridian
      value={
        dateValue.dateGte && dateValue.dateLte
          ? [dateValue.dateGte, dateValue.dateLte]
          : null
      }
      size="lg"
      onClean={() => {
        setDateValue({
          dateGte: null,
          dateLte: null,
        });
        const updateFilter = {
          ...filterValues,
          dateGte: null,
          dateLte: null,
        };
        setFilters(updateFilter, displayedFilters);
      }}
      onChange={(value) => {
        // 1. on initial select always set start and end of day
        // 2. if time is exactly 00:00:00, treat as date-only and use start/end of day
        // 3. if time is not exactly 00:00:00, use the exact time selected
        if (value && value[0] && value[1]) {
          const isStartMidnight =
            moment(value[0]).hour() === 0 &&
            moment(value[0]).minute() === 0 &&
            moment(value[0]).second() === 0;
          const isEndMidnight =
            moment(value[1]).hour() === 0 &&
            moment(value[1]).minute() === 0 &&
            moment(value[1]).second() === 0;

          const currentStartTime = moment(value[0]).format("HH:mm:ss");
          const currentEndTime = moment(value[1]).format("HH:mm:ss");

          let start = moment(value[0]).startOf("day").toDate();
          let end = moment(value[1]).endOf("day").toDate();

          if (!isStartMidnight || !isEndMidnight) {
            start = moment(value[0]).toDate();
            end = moment(value[1]).toDate();
          }

          if (moment(value[0]).isSame(moment(value[1]))) {
            start = moment(value[0]).startOf("day").toDate();
            end = moment(value[1]).endOf("day").toDate();
          }

          if (
            moment(currentStartTime, "HH:mm:ss").isSame(
              moment(currentEndTime, "HH:mm:ss")
            )
          ) {
            start = moment(value[0]).startOf("day").toDate();
            end = moment(value[1]).endOf("day").toDate();
          }

          setDateValue({
            dateGte: start,
            dateLte: end,
          });
          const updateFilter = {
            ...filterValues,
            dateGte: start,
            dateLte: end,
          };
          setFilters(updateFilter, displayedFilters);
        } else {
          setDateValue({
            dateGte: null,
            dateLte: null,
          });
          setFilters(
            {
              ...filterValues,
              dateGte: null,
              dateLte: null,
            },
            displayedFilters
          );
        }
      }}
    />
  );
};
